import { defineNuxtPlugin } from 'nuxt/app'
import MarkdownIt from 'markdown-it'

export default defineNuxtPlugin((nuxtApp) => {
  // Configure markdown-it with options
  const md = new MarkdownIt({
    html: true,
    linkify: true,
    typographer: true,
    breaks: true,
  })

  // Make markdown-it instance available in the app
  nuxtApp.provide('markdown', md)
})
